import apiConfig from "../config/api";

const apiLoginUrl = `${apiConfig.apiUri}api/login`;
const apiLoginTemp = `${apiConfig.apiUri}api/temp`;
const userApi = `${apiConfig.apiUri}api/user`;

const serieCI = sessionStorage.getItem("serieCI");
const usuarioRUT = sessionStorage.getItem("rut");

export const LoginUserApi = (loginData) =>
  fetch(`${apiLoginUrl}/V1`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: JSON.stringify({
      Username: loginData.Username,
      Password: loginData.Password,
      AuthType: loginData.AuthType,
      ApplicationId: apiConfig.applicationid,
      LoginType: loginData.LoginType,
    })
  });

export const GetEmailTokenApi = (userEmail) =>
  fetch(`${userApi}/emailtoken/${userEmail}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      "auth-rut": usuarioRUT,
      "auth-serie-ci": serieCI,
    }
  });

export const ValidateTokenApi = (AccessToken) =>
  fetch(`${apiLoginUrl}/validatetoken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: `Token=${AccessToken}&ApplicationId=${apiConfig.applicationid}`
  });

export const RefreshTokenApi = (refreshToken) =>
  fetch(`${apiLoginUrl}/refreshtoken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: `RefreshToken=${refreshToken}&ApplicationId=${apiConfig.applicationid}`
  });

export const LoginUserTempApi = (loginData) =>
  fetch(`${apiLoginTemp}/user/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    },
    body: JSON.stringify(loginData)
  });
